export default {
  a: {
    display: 'inline-block',
    fontWeight: 'bold',
    textAlign: 'center',
    textDecoration: 'none',
    WebkitTextSizeAdjust: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: '0 auto',
  },
}
